import { useTranslation } from 'react-i18next'

import { Text } from '@mercai/clever'

import { TabDocumentsProps } from './tab-documents.type'

import styles from './tab-documents.module.css'
import {
  getExternalDocuments,
  getInternalDocuments,
} from './tab-documents.constants'
import { CardDocuments } from '@/components'

export const TabDocuments = ({ saleOrder, isLoading }: TabDocumentsProps) => {
  const { t } = useTranslation('screenOrderCenterPage')
  const { t: tLogistic } = useTranslation('componentCardsOrderCenterShow')

  const internalDocuments = getInternalDocuments(t, tLogistic, saleOrder)
  const externalDocuments = getExternalDocuments(t, tLogistic, saleOrder)

  return (
    <>
      <div className={styles.container}>
        <div>
          <div className={styles.title}>
            <Text variant="title-medium">
              {t('orderCenterShowTabDocumentsInternalTitle')}
            </Text>
            <Text variant="text-small">
              {t('orderCenterShowTabDocumentsInternalDescription')}
            </Text>
          </div>

          <CardDocuments
            hasHeader={false}
            data={internalDocuments}
            isLoading={isLoading}
          />
        </div>

        <div>
          <div className={styles.title}>
            <Text variant="title-medium">
              {t('orderCenterShowTabDocumentsExternalTitle')}
            </Text>
            <Text variant="text-small">
              {t('orderCenterShowTabDocumentsExternalDescription')}
            </Text>
          </div>

          <CardDocuments
            hasHeader={false}
            data={externalDocuments}
            isLoading={isLoading}
          />
        </div>
      </div>
    </>
  )
}
